import { render, staticRenderFns } from "./ThgChargingStationProofDocumentTable.vue?vue&type=template&id=764931ac&scoped=true&"
import script from "./ThgChargingStationProofDocumentTable.vue?vue&type=script&lang=ts&"
export * from "./ThgChargingStationProofDocumentTable.vue?vue&type=script&lang=ts&"
import style0 from "./ThgChargingStationProofDocumentTable.vue?vue&type=style&index=0&id=764931ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "764931ac",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VIcon,VSimpleTable})
